import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Tooltip } from "primereact/tooltip";
import config from "../../config";
import debuglog from "../../util/helperutil";

// Function to update the event on the server (your API)
const updateEvent = async (eventData, eventId) => {
  try {
    // Replace with your actual API call
    const response = await fetch(`/api/events/${eventId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(eventData),
    });
    const data = await response.json();

    if (response.ok) {
      return data;
    } else {
      throw new Error("Failed to update event.");
    }
  } catch (error) {
    console.error("Error updating event:", error);
    return null;
  }
};

const SendInvitation = ({ event, onClose }) => {
  console.log("eventdetailsinvite", event);
  const [inviteDialogVisible, setInviteDialogVisible] = useState(false);
  const [invitedByInputDialogVisible, setInvitedByInputDialogVisible] = useState(false);
  const [wasDialogClosed, setWasDialogClosed] = useState(false);
  const [hostName, setHostName] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);

  const isInvitedByExists = !!event?.invitedBy?.trim();
  const shareToken = event?.shareToken;
  const shareUrl = `${config.INVITATION_URL}/${shareToken}`;
  const shareTitle = `Check out this event: ${event?.eventTitle}`;
  const whatsappMessage = encodeURIComponent(`${shareTitle} ${shareUrl}`);

  const toggleShareOptions = () => {
    if (isInvitedByExists) {
      setInviteDialogVisible(true);
    } else {
      setInvitedByInputDialogVisible(true);
    }
  };

  useEffect(() => {
    if (event && event.eventTitle && !wasDialogClosed) {
      toggleShareOptions();
    }
    return () => {
      // Clean up when the component is unmounted or dialog is closed
      setWasDialogClosed(true);
    };
  }, [event]);

  const hideDialog = () => {
    debuglog("called onclose")
    setInviteDialogVisible(false);
  if (onClose) {
    // Trigger the onClose callback when hiding the dialog
    onClose({ status: "closed" });
  }
  };
  const hideHostNameDialog = () => {
    debuglog("called onclose")
    setInvitedByInputDialogVisible(false);
    if (onClose) {
      onClose({ status: "cancelled" });
    }
  };
  const showAgain = () => {
    setWasDialogClosed(false);
    toggleShareOptions();
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        setCopySuccess(true);
        setTimeout(() => setCopySuccess(false), 2000);
      } else {
        console.error("Fallback copy failed.");
      }
    } catch (err) {
      console.error("Fallback: Unable to copy", err);
    }
    document.body.removeChild(textArea);
  };

  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          setCopySuccess(true);
          setTimeout(() => setCopySuccess(false), 2000);
        })
        .catch((err) => {
          console.error("Clipboard API failed, using fallback...", err);
          fallbackCopyTextToClipboard(shareUrl);
        });
    } else {
      fallbackCopyTextToClipboard(shareUrl);
    }
  };

  const handleShare = (platform) => {
    let url = "";
    const text = `${shareTitle} ${shareUrl}`;

    switch (platform) {
      case "whatsapp":
        url = `https://wa.me/?text=${encodeURIComponent(text)}`;
        break;
      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case "twitter":
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case "gmail":
        url = `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareUrl)}`;
        break;
      default:
        return;
    }

    window.open(url, "_blank");
  };

  // Full implementation of handleHostNameSubmit
  const handleHostNameSubmit = async (name, eventId) => {
    try {
      // Call your API to save the hostName
      const eventData = { invitedBy: name };
      const updatedEvent = await updateEvent(eventData, eventId);

      if (updatedEvent) {
        // Event updated successfully
        console.log("Event updated successfully.");
        setInviteDialogVisible(true);
        setInvitedByInputDialogVisible(false);
      } else {
        // Failed to update the event
        console.error("Failed to update event.");
        setInvitedByInputDialogVisible(false);
      }
    } catch (error) {
      // Handle API or network errors
      console.error("An error occurred while saving the host name", error);
      setInvitedByInputDialogVisible(false);
    }
  };

  return (
    <>
      <Dialog
        header="Invite"
        visible={inviteDialogVisible}
        style={{ width: "calc(100% - 15px)", maxWidth: "500px" }}
        modal
        onHide={hideDialog}
        headerStyle={{ margin: 0, padding: "15px 25px" }}
      >
        <div className="p-fluid">
          <div className="p-inputgroup mb-3">
            <div style={{ position: "relative", width: "100%" }}>
              <InputText
                value={shareUrl}
                readOnly
                style={{ flexGrow: 1, width: "100%", paddingRight: "58px" }}
              />
              <Button
                id="info-icon"
                label={copySuccess ? "Copied" : "Copy"}
                icon="pi pi-copy"
                onClick={handleCopy}
                style={{
                  position: "absolute",
                  right: "0",
                  borderRadius: "0 6px 6px 0",
                  backgroundColor: copySuccess ? "#FF895D" : "#0cc0df",
                }}
              />
              <Tooltip
                position="mouse"
                at="right+5 bottom"
                target="#info-icon"
                content="You can use this link to send invitation using any other method."
              />
            </div>
          </div>

          <div style={{ marginTop: "10px" }}>
            <label style={{ display: "block", marginBottom: "10px" }}>
              Share on Social Media
            </label>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button icon="pi pi-whatsapp" onClick={() => handleShare("whatsapp")} style={{ backgroundColor: "#25D366" }} />
              <Button icon="pi pi-facebook" onClick={() => handleShare("facebook")} style={{ backgroundColor: "#3B5998" }} />
              <Button icon="pi pi-twitter" onClick={() => handleShare("twitter")} style={{ backgroundColor: "#1DA1F2" }} />
              <Button icon="pi pi-envelope" onClick={() => handleShare("gmail")} style={{ backgroundColor: "#1DA1F2" }} />
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        header="Enter Host Name"
        visible={invitedByInputDialogVisible}
        style={{ width: "calc(100% - 15px)", maxWidth: "400px" }}
        modal
        onHide={hideHostNameDialog}
        footer={
          <div>
            <Button
              label="Submit"
              icon="pi pi-check"
              onClick={() => {
                handleHostNameSubmit(hostName, event.id);
                setInvitedByInputDialogVisible(false);
                setInviteDialogVisible(true);
              }}
              disabled={!hostName.trim()}
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={hideHostNameDialog}
              className="p-button-secondary"
            />
          </div>
        }
      >
        <div>
          <label style={{ display: "block", marginBottom: "10px" }}>
            Host Name<span style={{ color: "red" }}>*</span>
          </label>
          <InputText
            value={hostName}
            onChange={(e) => setHostName(e.target.value)}
            placeholder="Enter host name"
            style={{ width: "100%" }}
          />
        </div>
      </Dialog>
    </>
  );
};

export default SendInvitation;
